/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Support_Custom_AmountInputs */

const en_support_custom_amount = /** @type {(inputs: Support_Custom_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Or Forge a Custom Amount`)
};

const es_support_custom_amount = /** @type {(inputs: Support_Custom_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O Forja una Cantidad Personalizada`)
};

const fr_support_custom_amount = /** @type {(inputs: Support_Custom_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ou forger un montant personnalisé`)
};

const de_support_custom_amount = /** @type {(inputs: Support_Custom_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oder einen eigenen Betrag eingeben`)
};

const id_support_custom_amount = /** @type {(inputs: Support_Custom_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atau Masukkan Jumlah Kustom`)
};

/** @type {(inputs: Support_Custom_AmountInputs) => LocalizedString} */
const ja_support_custom_amount = en_support_custom_amount;

/** @type {(inputs: Support_Custom_AmountInputs) => LocalizedString} */
const zh_support_custom_amount = en_support_custom_amount;

/** @type {(inputs: Support_Custom_AmountInputs) => LocalizedString} */
const ar_support_custom_amount = en_support_custom_amount;

/** @type {(inputs: Support_Custom_AmountInputs) => LocalizedString} */
const it_support_custom_amount = en_support_custom_amount;

/** @type {(inputs: Support_Custom_AmountInputs) => LocalizedString} */
const ru_support_custom_amount = en_support_custom_amount;

/** @type {(inputs: Support_Custom_AmountInputs) => LocalizedString} */
const pt_support_custom_amount = en_support_custom_amount;

/** @type {(inputs: Support_Custom_AmountInputs) => LocalizedString} */
const ko_support_custom_amount = en_support_custom_amount;

/**
* | output |
* | --- |
* | "Or Forge a Custom Amount" |
*
* @param {Support_Custom_AmountInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const support_custom_amount = /** @type {((inputs?: Support_Custom_AmountInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Support_Custom_AmountInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_support_custom_amount(inputs)
	if (locale === "es") return es_support_custom_amount(inputs)
	if (locale === "fr") return fr_support_custom_amount(inputs)
	if (locale === "de") return de_support_custom_amount(inputs)
	if (locale === "ja") return ja_support_custom_amount(inputs)
	if (locale === "zh") return zh_support_custom_amount(inputs)
	if (locale === "ar") return ar_support_custom_amount(inputs)
	if (locale === "id") return id_support_custom_amount(inputs)
	if (locale === "it") return it_support_custom_amount(inputs)
	if (locale === "ru") return ru_support_custom_amount(inputs)
	if (locale === "pt") return pt_support_custom_amount(inputs)
	return ko_support_custom_amount(inputs)
});